import { combineReducers, createStore, applyMiddleware } from "redux";
import { routerMiddleware, connectRouter } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension";
import { reducer as formReducer } from "redux-form";
import { createLogger } from "redux-logger";
import { createBrowserHistory } from "history";
import { persistStore } from "redux-persist";
import { reducer as toastrReducer } from "react-redux-toastr";

import thunkMiddleware from "redux-thunk";
import createSagaMiddleware from "redux-saga";
import { middleware as sagaThunkMiddleware } from "redux-saga-thunk";
import { middleware as trackingMiddleware } from "../tracker";

import * as reducers from "../reducers";
import rootSaga from "../sagas";

import { isDevelopment } from "@/environment";

function configureStore() {
  const browserHistory = createBrowserHistory();
  const sagaMiddleware = createSagaMiddleware();

  const middleware = [sagaThunkMiddleware, sagaMiddleware, thunkMiddleware, routerMiddleware(browserHistory), trackingMiddleware];

  if (isDevelopment) {
    middleware.push(
      createLogger({
        predicate: (getState, action) => !/^@@.+/.test(action.type) && action.error,
        collapsed: (getState, action, logEntry) => !logEntry.error,
      })
    );
  }

  const routerReducer = connectRouter(browserHistory);

  const reducerObject = {
    ...reducers,
    router: routerReducer,
    form: formReducer,
    toastr: toastrReducer,
  };

  let rootReducer = combineReducers(reducerObject);

  const composeEnhancers = composeWithDevTools({
    // Specify name here, actionsBlacklist, actionsCreators and other options if needed
  });

  const store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware)));

  sagaMiddleware.run(rootSaga);

  const persistor = persistStore(store);

  if (module.hot) {
    module.hot.accept("../reducers", () => {
      import("../reducers").then((reducers) => {
        store.replaceReducer(
          combineReducers({
            ...reducers,
            form: formReducer,
            router: routerReducer,
            toastr: toastrReducer,
          })
        );
        persistor.persist();
      });
    });
  }

  return {
    store,
    persistor,
    history: browserHistory,
  };
}

export default configureStore;
